<script setup lang="ts">
import { useCurrentCustomerQuery } from "~/queries/finance/customers";

const { isLoggedIn } = useAuth();
const { setEstimatedUserAddress } = useEstimatedUserShippingAddress();
const { setShippingLocation } = useShippingLocation();

const isOpen = defineModel<boolean>({ default: false });

const onCountryChange = (countryCode: string) => {
  setEstimatedUserAddress({
    countryCode,
  });

  setShippingLocation(countryCode);
  isOpen.value = false;
};

const { data: customer } = useCurrentCustomerQuery();

const customerDefaultShippingAddress = computed(() =>
  customer.value?.addresses.find((a) => a.isShippingAddress),
);
</script>

<template>
  <BaseDialog v-model="isOpen">
    <BaseDialogContent>
      <template #title>{{ $t("estimatedAddressDialog.title") }}</template>

      <template #content>
        <p class="text-platform-text-2 mb-4 text-sm">
          {{ $t("estimatedAddressDialog.description") }}
        </p>

        <div>
          <BaseNuxtLinkButton
            link-path="/my-account/settings/addresses"
            button-width="full"
          >
            {{
              isLoggedIn
                ? $t("estimatedAddressDialog.manageYourAddresses")
                : $t("estimatedAddressDialog.signInToSeeYourAddresses")
            }}
          </BaseNuxtLinkButton>

          <BaseSeparatorLine
            v-if="!customerDefaultShippingAddress?.countryCode"
            class="mb-4"
          />

          <div v-if="!customerDefaultShippingAddress?.countryCode">
            <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
            <label
              for="country-select-input"
              class="block mb-3"
            >
              {{ $t("estimatedAddressDialog.countrySelectorLabel") }}
            </label>

            <BaseSelectCountryDropdown
              id="country-select-input"
              :label="undefined"
              :placeholder="
                $t('estimatedAddressDialog.countrySelectorPlaceholder')
              "
              validation="optional"
              @input="onCountryChange"
            />
          </div>
        </div>
      </template>
    </BaseDialogContent>
  </BaseDialog>
</template>
